import { render, staticRenderFns } from "./DisableP2PSaveVoiceSetting.vue?vue&type=template&id=f46e1846&scoped=true&"
import script from "./DisableP2PSaveVoiceSetting.vue?vue&type=script&lang=js&"
export * from "./DisableP2PSaveVoiceSetting.vue?vue&type=script&lang=js&"
import style0 from "./DisableP2PSaveVoiceSetting.vue?vue&type=style&index=0&id=f46e1846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46e1846",
  null
  
)

export default component.exports